const SESSION_KEY_PROFILE = 'profile';
const SESSION_KEY_SPACE = 'space';
const SESSION_KEY_RECENT_PROFILES = 'recent_profiles';

const getProfile = async () => {
    const response = await axios.get('/profile/read?include=image');
    return response.data.data;
}
const getSpace = async () => {
    const response = await axios.get('/settings');

    return response.data?.data?.space;
}

export const getSessionProfile = async () => {
    let profile = localStorage.getItem(SESSION_KEY_PROFILE);

    if (profile) {
        return JSON.parse(profile);
    }

    profile = await getProfile();
    localStorage.setItem(SESSION_KEY_PROFILE, JSON.stringify(profile));

    return profile;
}

export const getSessionSpace = async () => {
    let space = localStorage.getItem(SESSION_KEY_SPACE);

    if (space) {
        return JSON.parse(space);
    }

    space = await getSpace();

    if (!space) {
        return null;
    }

    localStorage.setItem(SESSION_KEY_SPACE, JSON.stringify(space));

    return space;

}

export const setSession = async () => {
    const profile = await getProfile();
    const space = await getSpace();

    if (profile) {
        localStorage.setItem(SESSION_KEY_PROFILE, JSON.stringify(profile));
    }

    if (space) {
        localStorage.setItem(SESSION_KEY_SPACE, JSON.stringify(space));
    }
}

const setRecentSessionProfiles = async (profile) => {
    let recentProfiles = localStorage.getItem(SESSION_KEY_RECENT_PROFILES);

    if (recentProfiles) {
        recentProfiles = JSON.parse(recentProfiles);
        let profileIndex = recentProfiles.findIndex((element) => element.id === profile.id);
        if (profileIndex !== -1) {
            recentProfiles.splice(profileIndex, 1);
        }

        recentProfiles.push(profile);
    } else {
        recentProfiles = [profile];
    }

    localStorage.setItem(SESSION_KEY_RECENT_PROFILES, JSON.stringify(recentProfiles));
}

export const setRecentSessionProfileFromCurrentSession = async () => {
    const profile = await getProfile();
    setRecentSessionProfiles(profile);
}

export const getRecentSessionProfiles = () => {
    let recentProfiles = localStorage.getItem(SESSION_KEY_RECENT_PROFILES);

    if (recentProfiles) {
        return JSON.parse(recentProfiles);
    }

    return [];
}

export const removeRecentSessionProfile = (profileId) => {
    let recentProfiles = localStorage.getItem(SESSION_KEY_RECENT_PROFILES);

    if (recentProfiles) {
        recentProfiles = JSON.parse(recentProfiles);
        let profileIndex = recentProfiles.findIndex((element) => element.id === profileId);
        if (profileIndex !== -1) {
            recentProfiles.splice(profileIndex, 1);
            localStorage.setItem(SESSION_KEY_RECENT_PROFILES, JSON.stringify(recentProfiles));
        }
    }
}


export const clearSession = () => {
    localStorage.removeItem(SESSION_KEY_PROFILE);
    localStorage.removeItem(SESSION_KEY_SPACE);
}
